import cn from 'classnames';
import type React from 'react';
import { ClockIcon, LibraryPlayButton } from '@shared/assets';
import { Card } from '@shared/ui';
import * as st from './VideoCard.module.scss';

type Props = {
  onClick: () => void;
  isActive: boolean;
  title: string;
  imageSrc?: string;
  imageClassName?: string;
  isVideoAvailableBySchedule?: boolean;
};

const VideoCard: React.FC<Props> = ({
  onClick,
  title,
  imageSrc,
  isActive,
  imageClassName,
  isVideoAvailableBySchedule = true,
}) => {
  return (
    <Card className={cn(st.card, isActive && st.active)} onClick={onClick}>
      <div className={st.imageWrapper}>
        <img src={imageSrc} alt={title} className={cn(st.image, imageClassName)} />
        <div className={st.imgOverlay}></div>
        <LibraryPlayButton className={st.playButton} />
      </div>
      <h4 className={st.card__title}>{title}</h4>
      {!isVideoAvailableBySchedule && <ClockIcon className={st.icon} />}
    </Card>
  );
};

export default VideoCard;
